var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCulture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.708,1.808v9.908a1.713,1.713,0,0,1-1.467,1.65l-.258.033a21.339,21.339,0,0,0-4.842,1.4A.831.831,0,0,1,0,14.025V2.433a.85.85,0,0,1,.45-.742A15.991,15.991,0,0,1,5.85,0H5.9A1.807,1.807,0,0,1,7.708,1.808Z",
    transform: "translate(10.625 2.234)",
    fill: "#8963f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.267,1.692A15.991,15.991,0,0,0,1.867,0H1.808A1.807,1.807,0,0,0,0,1.808v9.908a1.713,1.713,0,0,0,1.467,1.65l.258.033a21.339,21.339,0,0,1,4.842,1.4.831.831,0,0,0,1.142-.775V2.433A.833.833,0,0,0,7.267,1.692ZM2.508,4.217H4.383a.625.625,0,0,1,0,1.25H2.508a.625.625,0,1,1,0-1.25Zm2.5,3.75h-2.5a.625.625,0,1,1,0-1.25h2.5a.625.625,0,1,1,0,1.25Z",
    transform: "translate(1.658 2.234)",
    fill: "#8963f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    transform: "translate(20 20) rotate(180)",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCulture);
export default __webpack_public_path__ + "static/media/icon-culture.a6342d317a73378c9df73fc268b430ad.svg";
export { ForwardRef as ReactComponent };